import { InjectionToken } from '@angular/core';

export const IS_PUNCHOUT = new InjectionToken<boolean>('IsPunchout', {
  providedIn: 'root',
  factory: () => false,
});
